import _ from 'lodash';

function strEnum<T extends string>(arr: T[]) {
  const obj = {} as { [K in T]: K };
  _.forEach(arr, (key) => {
    obj[key] = key;
  });
  return obj;
}

type ActionSuffix = '' | '_STARTING' | '_DONE' | '_FAILED';
// eslint-disable-next-line
type Actions<T extends string> = `${T}${ActionSuffix}`;

export function constants<T extends string>(array: readonly T[]) {
  return strEnum(
    _.flatMap(array, (actionType) => [
      actionType,
      actionType + '_STARTING',
      actionType + '_DONE',
      actionType + '_FAILED',
    ]) as Array<Actions<(typeof array)[number]>>
  );
}
